import { useBlocker } from 'react-router-dom';

/**
 * El aviso de "tenés cambios sin guardar" al salir de la pantalla.
 *
 * Propio y no el de workflows (`WorkflowContext/hook`) por una razón concreta:
 * aquel navega a mano y solo ofrece "guardar y salir" o "salir", así que no
 * hay forma de QUEDARSE —y quedarse conservando el borrador es justamente lo
 * que esta pantalla necesita—. `useBlocker` ya trae las dos salidas:
 * `proceed()` sigue el camino que el usuario había pedido, `reset()` lo
 * cancela y deja todo como estaba, sin tocar el borrador.
 */
export function useUnsavedChanges(hasChanges: boolean) {
  const blocker = useBlocker(hasChanges);
  return {
    open: blocker.state === 'blocked',
    /** Salir: se pierde el borrador, y el usuario ya lo confirmó. */
    leave: () => blocker.proceed?.(),
    /** Quedarse: el borrador sigue intacto, tal como estaba. */
    stay: () => blocker.reset?.(),
  };
}
